import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp, ArrowDown } from "lucide-react";

/**
 * ScrollHelper — floating one-click jump for the (long) home page.
 * Near the top → jumps to the bottom; once scrolled down → jumps back to top.
 * Home route only.
 */
export default function ScrollHelper() {
  const { pathname } = useLocation();
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY + window.innerHeight;
      const full = document.documentElement.scrollHeight;
      setAtBottom(scrolled >= full - 120);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [pathname]);

  if (pathname !== "/") return null;

  const jump = () =>
    window.scrollTo({
      top: atBottom ? 0 : document.documentElement.scrollHeight,
      behavior: "smooth",
    });

  return (
    <button
      type="button"
      onClick={jump}
      aria-label={atBottom ? "Scroll to top" : "Scroll to bottom"}
      title={atBottom ? "Back to top" : "Jump to bottom"}
      className="candy-press fixed bottom-6 right-6 z-40 inline-flex h-12 w-12 items-center justify-center rounded-full border-2 border-ink bg-candy text-white shadow-sticker"
      data-testid="scroll-helper"
    >
      {atBottom ? <ArrowUp size={20} strokeWidth={3} /> : <ArrowDown size={20} strokeWidth={3} />}
    </button>
  );
}
